import { createContext, useContext, useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const TabContext = /*#__PURE__*/createContext(undefined);
export const TabProvider = ({
  tabIconStyleOverrides,
  tabLinkStyleOverrides,
  children
}) => {
  const value = useMemo(() => ({
    tabIconStyleOverrides,
    tabLinkStyleOverrides
  }), [tabIconStyleOverrides, tabLinkStyleOverrides]);
  return /*#__PURE__*/_jsx(TabContext.Provider, {
    value: value,
    children: children
  });
};

/**
 * Provides the context for the `Tab` component.
 * Note: The context is only available when the `Tab` component is rendered as an ancestor.
 * @returns TabContext - The context for the `Tab` component.
 * @returns TabContext.tabIconStyleOverrides - Style overrides to be applied to the `IconHolder` component.
 * @returns TabContext.tabLinkStyleOverrides - Style overrides to be applied to the `Link` component.
 */
export const useTabContext = () => {
  const tabContext = useContext(TabContext);
  return tabContext;
};